<template>
  <teleport to="#modal">
    <section :class="$style.modal">
      <FadeTransition>
        <div
          v-show="shown"
          :class="$style.modal__backdrop"
          @click.self="onClickBackdrop"
        />
      </FadeTransition>
      <transition
        name="slidein"
        :enter-active-class="$style['slidein--enter-active']"
        :leave-active-class="$style['slidein--leave-active']"
        :enter-from-class="$style['slidein--enter-from']"
        :leave-to-class="$style['slidein--leave-to']"
      >
        <div v-if="shown" :class="$style.modal__outer" :style="computedStyle">
          <div :class="$style.modal__content">
            <slot />
          </div>
        </div>
      </transition>
    </section>
  </teleport>
</template>

<script lang="ts">
import { defineComponent, watch, computed } from 'vue'
import FadeTransition from '@/components/transitions/FadeTransition.vue'

export default defineComponent({
  name: 'AppSlideModal',
  components: {
    FadeTransition,
  },
  props: {
    shown: {
      type: Boolean,
      default: false,
    },
    disableBackdrop: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '70%',
    },
  },
  emits: {
    opened: null,
    close: null,
    closed: null,
  },
  setup(props, { emit }) {
    const onClickBackdrop = () => {
      if (props.disableBackdrop) {
        return
      }
      emit('close')
    }

    watch(
      () => props.shown,
      (value, oldValue) => {
        if (value && !oldValue) {
          emit('opened')
        }
        if (!value && oldValue) {
          emit('closed')
        }
      }
    )

    const computedStyle = computed(() => ({
      width: props.width,
    }))

    return {
      onClickBackdrop,
      computedStyle,
    }
  },
})
</script>

<style lang="scss" module>
.slidein {
  // stylelint-disable selector-class-pattern
  &--enter-active,
  &--leave-active {
    transition: transform $transition-base;
  }

  &--enter-from,
  &--leave-to {
    transform: translateX(100%);
  }
  // stylelint-enable selector-class-pattern
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;

  &__outer {
    position: fixed;
    top: 0;
    right: 0;
    overflow: scroll;
    max-height: 100vh;
  }

  &__content {
    height: 100%;
  }

  &__backdrop {
    position: fixed;
    inset: 0;
    background-color: $color-surface-backdrop;
  }
}
</style>
